<!-- 董秘会员 -->
<template>
<div class="m-dm-member">
    <img class="member-bg" :src="require('@/common/images/member/m_member_bg.png')" />
    <div class="member-card-box">
        <div class="member-card">
            <div class="tips">{{dminfo.userlevel === 12 ? '已开通' : '暂未开通'}}</div>
            <div class="member-name">尊享VIP会员</div>
            <div class="member-sub-name">尊贵身份 会员特享</div>
            <div class="open-tips">开通会员享受更多会员专属权益</div>
        </div>
    </div>
    <div class="m-dm-member-content">
        <div class="title-box">
            会员尊享权益
        </div>
        <div class="equities-list">
            <div class="equities-item" v-for="(item, index) in equitiesList">
                <img class="icon" :src="item.icon" />
                <div class="label">{{ item.label }}</div>
                <div class="subname">{{ item.subname }}</div>
            </div>
        </div>
        <div class="title-box">
            收费标准
        </div>
        <div class="price-box">
            <div class="price">
                <div class="icon-name">
                    <img class="icon" :src="require('@/common/images/member/vip_icon.png')" />
                    <div class="name">尊享VIP会员</div>
                </div>
                <div class="value">8800元/年</div>
            </div>
        </div>
        <div class="title-box" style="margin-bottom: 12px;">
            入会条件
        </div>
        <div class="condition-box">
            <div class="title-tips">须符合以下其中一条</div>
            <div class="condition-item">
                <img class="icon" :src="require('@/common/images/member/condition_icon.png')" />
                <div class="text">上市公司:在职董秘、财总、证代、IR总监、董办成员及其他董监高、股东等;</div>
            </div>
            <div class="condition-item">
                <img class="icon" :src="require('@/common/images/member/condition_icon.png')" />
                <div class="text">拟上市公司:董事长、总经理、(拟任)董秘、财总、投融资总监、财务经理等;</div>
            </div>
            <div class="condition-item">
                <img class="icon" :src="require('@/common/images/member/condition_icon.png')" />
                <div class="text">发展型企业:董监高、董秘、财总、人力资源总监法务总监等;</div>
            </div>
            <div class="condition-item">
                <img class="icon" :src="require('@/common/images/member/condition_icon.png')" />
                <div class="text">投行圈机构:券商投行部、会计师、投行律师、投资机构等;</div>
            </div>
            <div class="condition-item">
                <img class="icon" :src="require('@/common/images/member/condition_icon.png')" />
                <div class="text">董秘俱乐部会员推荐，经俱乐部审核通过者。</div>
            </div>
        </div>
    </div>
    <div class="title-box">
        联系我们
    </div>
    <div class="link-way">
        <img class="service-code" :src="require('@/common/images/member/m_service_code.png')" />
        <div class="label">
            <p>董秘俱乐部-韦老师</p>
            <p>153 6100 1649（微信同号）</p>
        </div>
    </div>
    <div class="btn-box" v-if="dminfo.userlevel !== 12">
        <div class="btn-tips" v-if="dminfo.userlevel !== 0 && dminfo.userlevel !== 12">如需变更会员请联系工作人员</div>
        <div class="btn-item-box" v-if="dminfo.userlevel === 0">
            <div class="btn-disabled">成为会员终身享有11大权益</div>
            <div class="now-join-btn" @click="handleJoin">立即加入</div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getAccountDmInfo} from '@/api/member.js'
export default {
    data() {
        return {
            equitiesList: [
                {label: '线上学习', subname: '价值8800元', icon: require('@/common/images/member/xsxx_icon.png')},
                {label: '大咖直播', subname: '每年超12场次', icon: require('@/common/images/member/dkzb_icon.png')},
                {label: '标杆企业参访', subname: '价值680/场', icon: require('@/common/images/member/bgqycf_icon.png')},
                {label: '会员猎聘', subname: '岗位推荐/人才引荐', icon: require('@/common/images/member/hylp_icon.png')},
                {label: '职业规划', subname: '一对一职业规划', icon: require('@/common/images/member/zygh_icon.png')},
                {label: '企业宣传', subname: '提供企业曝光', icon: require('@/common/images/member/qyxc_icon.png')},
                {label: '考试辅导', subname: '董秘资格证考试指导', icon: require('@/common/images/member/ksfd_icon.png')},
                {label: 'IP打造服务', subname: '传记撰写', icon: require('@/common/images/member/ipdzfw_icon.png')},
                {label: '资源对接', subname: '机构资源对接', icon: require('@/common/images/member/zydj_icon.png')},
                {label: '专属联动优惠', subname: '董秘、财总课程7折', icon: require('@/common/images/member/zsldyh_icon.png')},
                {label: '董秘峰会', subname: '价值3980元/人', icon: require('@/common/images/member/dmfh_icon.png')}
            ],
            dminfo: {
                headurl: '',
                isexpirelong: 0,
                loginmobileno: '',
                nickname: '',
                usercode: '',
                userexpiredate: '',
                userlevel: 0,
                verifyinfo: {},
                verifystatus: 0
            }
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(!this.domainInfo.isMobile) {
            this.$router.push({
                name: 'DmMember'
            })
        } else {
            if (this.user.isLogin) {
                this.handleGetAccountDmInfo()
            }
            this.setClientType(2)
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '董秘会员-加入会员'
    },
    methods: {
        handleGetAccountDmInfo() {
            this.setLoading(true)
            getAccountDmInfo({
                data: {},
                success: res => {
                    this.setLoading(false)
                    this.dminfo = res.data
                },
                error: res => {
                    this.setLoading(false)
                }
            })
        },
        handleJoin() {
            if (this.user.isLogin) {
                this.$router.push({
                    name: 'MDmMemberDataInput'
                })
            } else {
                this.$router.push({
                    name: 'MLogin'
                })
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser',
            'setClientType'
        ])
    },
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    watch: {
        'user': {
            handler(newV) {
                if (!oldV.isLogin && newV.isLogin) {
                    this.handleGetAccountDmInfo()
                } else if (!newV.isLogin) {
                    this.dminfo = {
                        headurl: '',
                        isexpirelong: 0,
                        loginmobileno: '',
                        nickname: '',
                        usercode: '',
                        userexpiredate: '',
                        userlevel: 0,
                        verifyinfo: {},
                        verifystatus: 0
                    }
                }
            },
            deep: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-dm-member {
    background-color: #fff;
    height: 100vh;
    padding: 0 0.28rem 1.56rem;
    box-sizing: border-box;
    overflow: auto;
    position: relative;
    z-index: 1;
    .member-bg {
        width: 100vw;
        height: 4.63rem;
        position: absolute;
        top: 0;
        z-index: -1;
        left: 0;
    }
    .member-card-box {
        padding: 0.4rem 0;
        box-sizing: border-box;
        .member-card {
            width: 100%;
            height: 3.23rem;
            background: url('../../../common/images/member/m_member_card_bg.png') no-repeat;
            background-size: 100% 100%;
            border-radius: 0.1rem;
            overflow: hidden;  
            .tips {
                width: 1.2rem;
                height: 0.36rem;
                background: rgba(0,0,0,0.6);
                text-align: center;
                line-height: 0.36rem;
                color: #cccccc;
                font-size: 0.2rem;
                margin-bottom: 0.36rem
            }
            .member-name {
                font-size: 0.42rem;
                color: #FFF5E5;
                line-height: 0.6rem;
                font-weight: bold;
                padding-left: 0.28rem;
                margin-bottom: 0.1rem;
            }
            .member-sub-name {
                font-size: 0.24rem;
                color: #FFF5E5;
                line-height: 0.34rem;
                padding-left: 0.28rem;
                margin-bottom: 1rem;
            }
            .open-tips {
                font-size: 0.2rem;
                color: #FFF5E5;
                line-height: 0.28rem;
                padding-left: 0.37rem;
            }
        }
    }
    .title-box {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.2rem;
        font-size: 0.32rem;
        line-height: 0.45rem;
        color: #333333;
        font-weight: 700;
        margin-bottom: 0.4rem;
        &::before,
        &::after {
            content: '';
            width: 0.28rem;
            height: 0.14rem;
            border-radius: 0.14rem;
        }
        &::before {
            background: linear-gradient(90deg, #D0A87A 0%, rgba(208, 168, 122, 0.2) 100%);
        }

        &::after {
            background: linear-gradient(to left, #D0A87A 0%, rgba(208, 168, 122, 0.2) 100%);
        }
    }
    .m-dm-member-content {
        padding: 0.4rem 0.2rem 0.12rem;
        background: #fff;
        box-shadow: 0px 0.02rem 0.08rem 0px rgba(0,0,0,0.2);
        border-radius: 0.2rem;
        margin-bottom: 0.6rem;
        .equities-list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0.6rem;
            .equities-item {
                width: 1.63rem;
                text-align: center;
                margin-bottom: 20px;
                .icon {
                    width: 0.86rem;
                    height: 0.86rem;
                    margin: 0 auto 0.1rem;
                }
                .label {
                    font-size: 0.24rem;
                    line-height: 0.34rem;
                    color: #333333;
                }
                .subname {
                    font-size: 0.2rem;
                    color: #999999;
                    line-height: 0.28rem;
                    white-space: nowrap;
                }
            }
        }
        .price-box {
            padding: 0 0.08rem;
            margin-bottom: 0.6rem;
            .price {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border: 2px solid #D4B077;
                box-shadow: 0px 0.02rem 0.08rem 0px rgba(0,0,0,0.25);
                border-radius: 0.1rem;
                height: 1.32rem;
                background: #FFFAF1;
                box-sizing: border-box;
                .icon-name {
                    display: flex;
                    align-items: center;
                    padding-left: 0.2rem;
                    .icon {
                        width: 0.8rem;
                        height: 0.8rem;
                        margin-right: 0.2rem;
                    }
                    .name {
                        font-size: 0.32rem;
                        color: #815F34;
                        font-weight: bold;
                    }
                }
                .value {
                    font-size: 0.32rem;
                    color: #815F34;
                    font-weight: bold;
                    padding-right: 0.4rem;
                }
            }
        }
        .title-tips {
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #999999;
            text-align: center;
            margin-bottom: 0.2rem;
        }
        .condition-box {
            .condition-item {
                display: flex;
                align-items: center;
                padding: 0.28rem 0.2rem;
                background: linear-gradient( 90deg, #FFFFFF 0%, #FFF0D1 0%, #FEF9EF 100%);
                border-radius: 0.1rem;
                margin-bottom: 0.2rem;
                .icon {
                    width: 0.4rem;
                    height: 0.4rem;
                    margin-right: 0.2rem;
                }
                .text {
                    font-size: 0.28rem;
                    color: #8C754A;
                    line-height: 0.46rem;
                }
            }
        }
    }
    .link-way {
        .service-code {
            width: 2rem;
            height: 2rem;
            margin: 0 auto 0.2rem;
        }
        .label {
            font-size: 0.32rem;
            text-align: center;
            color: #333333;
            line-height: 0.45rem;
        }
    }
    .btn-box {
        height: 1.2rem;
        background: #fff;
        padding: 0 0.28rem 0.2rem;
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        .btn-tips {
            width: 100%;
            height: 1rem;
            text-align: center;
            line-height: 1rem;
            background: #2C2528;
            color: #F8E7DD;
            border-radius: 0.1rem;
            font-size: 0.3rem;
        }
        .btn-item-box {
            border-radius: 0.1rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            .btn-disabled {
                height: 1rem;
                text-align: center;
                line-height: 1rem;
                background: #2C2528;
                color: #F8E7DD;
                border-radius: 0.1rem 0 0 0.1rem;
                font-size: 0.3rem;
                width: 4.54rem;
            }
            .now-join-btn {
                width: 2.4rem;
                height: 1rem;
                background: linear-gradient( 90deg, #FBE9DA 0%, #E2BDA0 100%);
                text-align: center;
                line-height: 1rem;
                color: #333333;
                font-size: 0.32rem;
            }
        }
    }
}
</style>